import Caroucel from "../../components/carousel/Carousel";
import "./Public.css";

const Public = () => {
  return (
    <div className="public-section">
      <div className="public-title">Nuestras publicaciones:</div>
      <div className="carousel-wrapper">
        <Caroucel />
      </div>
    </div>
  );
};

export default Public;
